module.exports = __webpack_public_path__ + "static/media/vegitables_43.2db0991d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_43.csv
// module id = 628
// module chunks = 0